// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HUQBYnWtYLCqVgSCWm2R {
  padding: .6rem;
  display: flex;
  flex-direction: column;
  gap: .6rem;
}

.xgPprS09bklmTK11F58V {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
}

.rZIto8ABcaFJfRTZc85z {
  white-space: nowrap;
  font-weight: 600;
}

.dC3I9E0AeqRp0C8oJTtK {
  margin: 0;
  font-size: .85rem;
  color: var(--c-muted);
}
`, "",{"version":3,"sources":["webpack://./src/server/public/sites/client/gallery/components/choosePayment/shipping.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,qBAAqB;AACvB","sourcesContent":[".container {\r\n  padding: .6rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: .6rem;\r\n}\r\n\r\n.option {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  width: 100%;\r\n}\r\n\r\n.price {\r\n  white-space: nowrap;\r\n  font-weight: 600;\r\n}\r\n\r\n.description {\r\n  margin: 0;\r\n  font-size: .85rem;\r\n  color: var(--c-muted);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var container = `HUQBYnWtYLCqVgSCWm2R`;
export var option = `xgPprS09bklmTK11F58V`;
export var price = `rZIto8ABcaFJfRTZc85z`;
export var description = `dC3I9E0AeqRp0C8oJTtK`;
export default ___CSS_LOADER_EXPORT___;
